const faqs = [
  {
    q: '腐漫画网上的所有作品都是免费的吗？',
    a: '是的！腐漫画网始终坚持全本免费阅读，站内所有韩漫腐、日漫腐、国漫耽美作品均不收取任何费用，无需充值会员即可畅读全部内容。',
  },
  {
    q: '网站的作品多久更新一次？',
    a: '我们拥有专业的编辑团队，每日凌晨 24:00 准时更新热门腐漫推荐与新番连载内容，完结作品也会持续补充，确保读者每天都有新内容可看。',
  },
  {
    q: '支持哪些设备阅读？',
    a: '腐漫画网采用响应式网页设计，完美适配桌面电脑、平板和手机等各类设备。打开浏览器即可阅读，无需下载任何 APP，随时随地畅享追漫乐趣。',
  },
  {
    q: '下拉式阅读是什么意思？',
    a: '下拉式阅读是一种连续阅读模式，你只需向下滑动页面，内容便会自动加载下一章节，无需手动点击"下一页"按钮，带来如瀑布般流畅的沉浸式阅读体验。',
  },
  {
    q: '网站收录了哪些类型的腐漫作品？',
    a: '我们覆盖韩漫腐、韩漫耽美、日漫腐、国漫耽美等主流风格，题材包括校园纯爱、古风仙侠、都市总裁、奇幻异世界、悬疑推理、ABO世界观等，满足各类腐漫爱好者的口味。',
  },
  {
    q: '如何找到自己想看的作品？',
    a: '你可以通过首页的热门话题标签、精选推荐版块、人气排行榜单以及专题合集等多种方式发现感兴趣的作品，搜索功能和分类导航也在持续优化中。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">关于腐漫画网的常见疑问解答</p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq) => (
            <div
              key={faq.q}
              className="rounded-xl bg-background-100 border border-background-200/70 p-5 md:p-6"
            >
              <h3 className="flex items-start gap-3 text-sm md:text-base font-semibold text-foreground-900">
                <span className="flex-shrink-0 w-5 h-5 md:w-6 md:h-6 mt-0.5 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-xs font-bold">
                  Q
                </span>
                {faq.q}
              </h3>
              <p className="mt-3 pl-8 md:pl-9 text-xs md:text-sm text-foreground-600 leading-relaxed">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}